module.exports = __webpack_public_path__ + "static/img/pp-info-demo-txs@2x.bf2bd9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pp-info-demo-txs@2x.png
// module id = isl3
// module chunks = 1